import React from 'react';

const ExternalLinkIcon = () => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.9974 2.00008H1.9974C1.64377 2.00008 1.30464 2.14056 1.05459 2.39061C0.804538 2.64065 0.664063 2.97979 0.664062 3.33341V10.0001C0.664063 10.3537 0.804538 10.6928 1.05459 10.9429C1.30464 11.1929 1.64377 11.3334 1.9974 11.3334H8.66406C9.01768 11.3334 9.35682 11.1929 9.60687 10.9429C9.85692 10.6928 9.9974 10.3537 9.9974 10.0001V6.00008M5.33073 6.66675L11.3307 0.666748M11.3307 0.666748H7.9974M11.3307 0.666748V4.00008'
        stroke='#5b91f5'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default ExternalLinkIcon;
